<template>
  <div class="w3-main main-container">

    <page-header />

    <!-- About -->
    <about-content />

    <!-- News -->
    <div class="w3-container about-container">
      <h1 class="w3-xxxlarge"><b>{{ $t('News') }}</b></h1>

      <hr class="w3-round">

      <news-article
        v-for="(article, index) in news.slice(0, 3)"
        :key="article._id"
        :article="article"
        :no-separator="index === news.slice(0, 3).length - 1"
      />

      <router-link :to="'/hireink'">
        <button
          class="w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
        >
          {{ $t('More News') }}
        </button>
      </router-link>
    </div>

    <!-- Items -->
    <div class="w3-container about-container" id="termekeink">
      <h1 class="w3-xxxlarge"><b>{{ $t('Our products') }}</b></h1>
      <hr class="w3-round">
      <p>{{ $t('Products text') }}</p>

      <div class="items-images-container">
        <div v-for="itemCategory in itemCategories">
          <router-link :to="`/termekeink/${itemCategory._id}`">
            <div class="item-category-name-layer">
              <h2>{{ itemCategory.name[locale] }}</h2>
            </div>
            <img
              :src="`static/images/item_categories/${itemCategory.image}`"
            />
          </router-link>
        </div>
      </div>

      <router-link to="/termekeink">
        <button
          class="w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
        >
          {{ $t('More products') }}
        </button>
      </router-link>
    </div>

    <!-- Constructor -->
    <!--<div class="w3-container about-container" id="tervezo">
      <h1 class="w3-xxxlarge"><b>{{ $t('Designer') }}</b></h1>
      <hr class="w3-round">
      <p>
        Tervezze meg konyhahátfalát vagy üvegajtaját a tervező segítségével.
        A minták alapján elkészített látványtervet elküldheti nekünk amit mi megvalósítunk.
      </p>
    </div>-->

    <!-- Contact -->
    <contact-content />
  </div>
</template>

<i18n>
  {
    "de": {
      "News": "Nachrichten",
      "More News": "Weitere Nachrichten",
      "Our products": "Unsere Produkte",
      "Products text": "Eine Glasplatte kann mehrere Funktionen erfüllen.",
      "More products": "Weitere Produkten",
      "Designer": "Designer"
    },
    "en": {
      "News": "News",
      "More News": "More news",
      "Our products": "Our products",
      "Products text": "A sheet of glass can fulfill multiple functions.",
      "More products": "More products",
      "Designer": "Designer"
    },
    "hu": {
      "News": "Híreink",
      "More News": "További hírek",
      "Our products": "Termékeink",
      "Products text": "Egy üveglap több funkciót is betölthet.",
      "More products": "További termékek",
      "Designer": "Tervező"
    }
  }
</i18n>

<script>
  import PageHeader from '@/components/PageHeader';
  import AboutContent from '@/components/AboutContent';
  import NewsArticle from '@/components/NewsArticle';
  import ContactContent from '@/components/ContactContent';
  import news from 'static/data/news.json';
  import itemCategories from 'static/data/home-item-categories.json';

  export default {
    name: 'home',
    data() {
      return {
        itemCategories,
        news,
      };
    },
    created() {
      document.title = 'Kreatív megoldások üvegre | BeCreative';
    },
    mounted() {
      scrollTo(0, 0);
    },
    computed: {
      locale() {
        return this.$store.state.i18n.locale;
      },
    },
    components: {
      PageHeader,
      AboutContent,
      NewsArticle,
      ContactContent,
    },
  };

</script>


<style scoped>
  a {
    text-decoration: none;
  }

  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

  button {
    background-color: #eb2e4a !important;
  }

  .about-container {
    margin-top: 75px;
    max-width: 1000px;
  }

  .items-images-container {
    max-width: 1000px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 30px;
  }

  .items-images-container div {
    cursor: pointer;
    position: relative;
    margin: 5px;
  }

  .items-images-container img {
    width: 100%;
  }

  @media (max-width: 1217px) {
    .items-images-container {
      justify-content: center;
    }

    .items-images-container div {
      width: 100%;
      max-width: 512px;
      margin: 0;
    }
  }

  @media (max-width: 992px) {
    .items-images-container {
      justify-content: flex-start;
    }

    .items-images-container div {
      width: initial;
      margin: 5px;
    }
  }

  @media (max-width: 836px) {
    .items-images-container {
      justify-content: center;
    }

    .items-images-container div {
      width: 100%;
      max-width: 512px;
      margin: 0;
    }
  }

  .item-category-name-layer {
    position: absolute !important;
    margin: 0 !important;
    height: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0.7);
    display: table;
  }

  .item-category-name-layer:hover {
    opacity: 0;
  }

  .item-category-name-layer h2 {
    width: 100%;
    word-spacing: 100vw;
    margin: 0;
    text-align: center;
    font-weight: 600;
    color: #eb2e4a !important;
    line-height: 1.2;
    display: table-cell;
    vertical-align: middle;
    font-size: 26px;
  }

  @media (max-width: 400px) {
    .item-category-name-layer h2 {
      font-size: 24px;
    }
  }

</style>



// WEBPACK FOOTER //
// Home.vue?4bf8ae48